import { useParams } from 'react-router-dom';
import {
  Breadcrumbs,
  BreadcrumbsItem,
} from '../../../../core/components/organism/Breadcrumbs';
import { getDisciplineName } from '../../../../core/utils/new_discipline';
import { useLessonContentStore } from '../../stores/lessonContentStore';
import { getModuleLabel } from '../../utils/contentHelper';

function LessonBreadcrumbsHeader() {
  const { discipline, module } = useParams();
  const { lesson } = useLessonContentStore();

  const breadcrumbItems: BreadcrumbsItem[] = [
    {
      label: discipline ? getDisciplineName(discipline).replace('Humana', '') : '',
      href: `/disciplinas/${discipline}`,
    },
    {
      label: getModuleLabel(module || ''),
      href: `/disciplinas/${discipline}/modulo/${module}/tipo/videoaula`,
    },
    {
      label: lesson?.title || '',
      href: '#',
    },
  ];

  return (
    <>
      <Breadcrumbs items={breadcrumbItems} />
    </>
  );
}

export { LessonBreadcrumbsHeader };
